import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { LayoutsModule } from './common/layouts/layouts.module';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { NgxStripeModule } from 'ngx-stripe';

@NgModule({
    declarations: [AppComponent],

    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        CoreModule,
        LayoutsModule,
        SharedModule,
        NgxStripeModule.forRoot()
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
